import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { KomodoCoreWrappersModule } from '@komodo-design-system/komodo-core-angular-twelve-wrappers/dist/komodo-core-wrappers';

import { ChipsListComponent } from './chips-list.component';

@NgModule({
  declarations: [ChipsListComponent],
  imports: [KomodoCoreWrappersModule, BrowserModule],
  exports: [ChipsListComponent],
  providers: []
})
export class ChipsListModule {}
